import React from 'react';
import PropTypes from 'prop-types';
import 'd3';
import NVD3Chart from 'react-nvd3';

import Header from '../../../components/Chart/Header';
import Legend from '../../../components/Chart/Legend';
import {
  formatEthnicityData,
  getEnrollmentData,
  donutCallback,
  donutTooltip,
  formatValueAsPercent,
} from '../../../utils/charts';

import 'nvd3/build/nv.d3.css';
import './styles.css';

class Ethnicity extends React.PureComponent {
  static props = {
    ethnicity: PropTypes.object,
    schoolSize: PropTypes.object,
    isCamino: PropTypes.bool,
  };

  onRenderEnd = () => {
    const { schoolSize } = this.props;
    const enrollmentData = getEnrollmentData(schoolSize);

    donutCallback('#ethnic-data-container', enrollmentData[2], ['Total Students']);
  };

  render() {
    const { ethnicity, isCamino } = this.props;
    const data = formatEthnicityData(ethnicity, isCamino);
    return data.length > 0 ? (
      <div name="student-body" className="ethnicity common-full-width">
        <div className="understanding-header common-core-width">
          Understanding the student body
        </div>
        <div
          id="ethnic-data-container"
          className="ethnicity-data-container common-core-width"
          data-cy="ethnic-data-container"
        >
          <div className="pie-chart-container">
            <Header title="Ethnicity" />
            <NVD3Chart
              id="ethnicData"
              type="pieChart"
              datum={data}
              x="line1"
              y="value"
              margin={{ top: 0, left: 0, bottom: 0, right: 0 }}
              donut
              showLegend={false}
              labelType="value"
              donutRatio={0.45}
              showLabels
              showValues
              duration={250}
              labelThreshold={0.05}
              growOnHover
              renderEnd={this.onRenderEnd}
              valueFormat={formatValueAsPercent}
              tooltip={donutTooltip}
              padAngle={0.005}
            />
          </div>
          <Legend data={data} />
        </div>
      </div>
    ) : null;
  }
}

export default Ethnicity;
